export default class Subnav {
  constructor(el) {
    this._el = el
    this._toggler = this._el.querySelector('.wz-sticky-bar__nav-toggler')

    this._attachEvents()
  }

  _attachEvents() {
    this._toggler.addEventListener('click', this.toggle.bind(this))
  }

  toggle() {
    this._el.classList.toggle('wz-sticky-bar--active')
  }
}
